module.exports = __webpack_public_path__ + "static/img/JP.fb255fbb.png";